import { Stack, Typography } from '@mui/material';
import { TableChartOutlined, SearchOffOutlined } from '@mui/icons-material';

export const NoRowsGrid = () => {
  return (
    <Stack
      height="100%"
      alignItems="center"
      justifyContent="center"
      spacing={4}
    >
      <TableChartOutlined sx={{ fontSize: 60, color: 'text.secondary' }} />
      <Typography variant="h6">No rows found</Typography>
    </Stack>
  );
};

export const NoResultsGrid = () => {
  return (
    <Stack height="100%" alignItems="center" justifyContent="center" spacing={4}>
      <SearchOffOutlined sx={{ fontSize: 60, color: 'text.secondary' }} />
      <Typography variant="h6">Local filter returns no result</Typography>
    </Stack>
  );
};
